export default "__VITE_ASSET__CFZmhcD2__"